enum boardItemTypes {
  VENDOR_VARIANTS= 'VENDOR_VARIANTS',
  ASSETS= 'ASSETS',
}

export default boardItemTypes;
